
const experience = [
    {
        title: "Team Lead Development",
        company: "KapilIT Solutions Pvt Ltd",
        duration: "Dec 2021 - Present",
        responsibilities: [
            "Led a full-stack team to build enterprise-grade applications using Angular, Node.js, and PostgreSQL.",
            "Supervised teams and individuals, giving feedback on performance and setting goals for improvement.",
            "Monitored team operations and workflow during busy periods, adjusting to improve pace.",
            "Identified areas of improvement and implemented necessary changes.",
            "Helped mitigate and resolve issues by analyzing situations and implementing appropriate solutions."
        ]
    },
    {
        "title": "Team Lead",
        "company": "KCS Software Solutions",
        "duration": "Mar 2021 - Dec 2021",
        "responsibilities": [
            "Developed and maintained Angular + Node.js web applications for enterprise clients.",
            "Integrated secure REST APIs for seamless communication between frontend & backend.",
            "Monitored team operations and workflow during busy periods, making adjustments to improve pace.",
            "Implemented strategies to improve overall team efficiency.",
            "Helped mitigate and resolve issues by analyzing situations and implementing appropriate solutions."
        ]
    },
    {
        "title": "Senior Software Engineer",
        "company": "Excelra Knowledge Solutions",
        "duration": "Jul 2019 - Feb 2021",
        "responsibilities": [
            "Frontend UI Development, API integration with Frontend through Angular 7+, HTML, CSS, Javascript.",
            "Collaborated with cross-functional teams to ensure seamless integration of software components.",
            "Developed efficient software solutions to meet client requirements.",
            "Resolved critical production issues by debugging code, analyzing logs, and collaborating with support teams."
        ]
    },
    {
        "title": "Software Developer",
        "company": "Jaguar Software India",
        "duration": "Apr 2019 - Jun 2019",
        "responsibilities": [
            "Built and optimized data-driven applications using D3.js, AngularJS, and PostgreSQL.",
            "Debugged software issues to ensure optimal performance and minimize system downtime.",
            "Collaborated with cross-functional teams to design, develop, and implement new features."
        ]
    },
    {
        "title": "Developer",
        "company": "Successmetric Pvt Ltd",
        "duration": "May 2018 - Apr 2019",
        "responsibilities": [
            "Developed Odoo-based ERP applications with Flask and Angular.",
            "Created interactive frontend dashboards for enterprise clients.",
            "Optimized existing code for improved efficiency, readability, and maintainability.",
            "Collaborated with cross-functional teams to design, develop, and implement new features."
        ]
    },
    {
        "title": "Application Developer",
        "company": "NIIT Technologies",
        "duration": "May 2016 - May 2018",
        "responsibilities": [
            "Implemented customized Odoo applications and developed secure Node.js & Angular-based solutions.",
            "Implemented and customized applications according to client requirements."
        ]
    },
    {
        "title": "Associate",
        "company": "HCL Technologies Ltd",
        "duration": "Dec 2013 - Jan 2016",
        "responsibilities": [
            "Developed Fleet Management System using Odoo and trained police personnel across districts.",
            "Built interactive dashboards for real-time tracking & analytics."
        ]
    }
]
export default experience;
